import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-28" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-29" data-mp="vsmmuobpowcn">
        <div className="mb-12 text-center" data-id="element-30" data-mp="vuh863qwaqh9">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-31" data-mp="qtt8yusij3by">
            INCLUSI OGGI
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-32" data-mp="14r7zy3yezj61">🎁 5 Bonus Esclusivi</h2>
          <p className="mt-4 text-brand-gray" data-id="element-33" data-mp="zsn8asx8a7t7">
            Valore <span className="font-bold text-brand-purple line-through" data-id="element-34" data-mp="1ei2ndbnecot2">100 €</span> — oggi tuoi senza costi
            aggiuntivi.
          </p>
        </div>
        <div className="space-y-3" data-id="element-35" data-mp="1njsppcith85m">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-36" data-mp="1nhpp5yk1fwmn" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-37" data-mp="3psogy5gym1m3">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Copertina di ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-38" data-mp="2np5ieutpm2y" />
              <div className="min-w-0 flex-1" data-id="element-39" data-mp="gklra1w34dcz">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-40" data-mp="gjani22n35lv">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-41" data-mp="lcvp043fyhpt">
                  <span className="text-brand-gray" data-id="element-42" data-mp="qbq6n2poa08c">{bonus.description}</span>
                  <span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-43" data-mp="va9uj8nttm3c">valore {bonus.price}</span>
                  <span className="ml-2 font-extrabold text-brand-teal" data-id="element-44" data-mp="1094lwyzv0iz2">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}